import { h, Fragment } from "preact";
import { useState, useRef } from "preact/hooks";
import SizeGuideContent from "./size-guide-content";

export default function SizeGuideTrigger({
  sizeGuide,
  className = "size-guide-trigger link link--x-small",
  children,
}) {
  const [isOpen, setOpen] = useState(false);
  const buttonRef = useRef();

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => {
          setOpen(!isOpen);
        }}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        ref={buttonRef}
      >
        {children || window.localeStrings.product.size_guide}
      </button>
      <SizeGuideContent
        isOpen={isOpen}
        sizeGuide={sizeGuide}
        onClose={() => setOpen(false)}
        returnFocusRef={buttonRef}
      />
    </>
  );
}
